import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { OdometerLogTrailModel } from "../models/odometerlogtrail.model";
import { OdometerLogTrailService } from "../models/odometerlogtrail.service";
import { Observable } from "rxjs/Observable";
import { IKeyValueInterface, WeGoAuthorizedLink, Permission, PermissionType, RoleLevel } from "./../../shared/config";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";

@Component({
  selector: "wego-odometerlogtrail",
  template: require('../views/odometerlogtrail-list.component.html'),
  providers: [OdometerLogTrailService],
  styles: [
    `
  .nowrap{
    white-space: nowrap;
   } 
   :host /deep/ .sort-icon {
    float: none !important;    
  }
  `
  ]
})
export class OdometerLogTrailListComponent implements OnInit {
  DataListModel: DataListModel;
  odometerLogTrailList: OdometerLogTrailModel[];
  model: OdometerLogTrailModel = new OdometerLogTrailModel();
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  urlDefaultPage: string;
  urlOdometerLogTrailUpdate: string;
  urlOdometerLogTrailAdd: string;
  urlPersonInfo: string;
  errorModel: IKeyValueInterface[];
  classType: string;
  isParentCheck: boolean;
  isParentCheckEnable: boolean;
  LblAddDescriptionOfDeviation: string;
  LblIcon: string;
  chkDescription: boolean = false;
  addOdometerLogTrailLink: WeGoAuthorizedLink;
  roleLevel = RoleLevel;
  
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("descriptionModal") public descriptionModal: any;

  get isAnyChecked(): boolean {
    if (this.odometerLogTrailList) {
      let isCheck = this.odometerLogTrailList.some(x => x.isChecked == true);
      if (isCheck) {
        if (
          this.odometerLogTrailList
            .filter(x => x.descriptionOfDeviation == null)
            .every(x => x.isChecked == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isEditAccess(): boolean {
    if (this.odometerLogTrailList){
      return this.odometerLogTrailList.some(x => x.isEditable);
    }
    else{ return false; }
      
  }

  constructor(
    private odometerLogTrailService: OdometerLogTrailService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.LblAddDescriptionOfDeviation = this.translate.instant(
      "LblAddDescriptionOfDeviation"
    );
    this.LblIcon = "fa fa-comments";
    this.module = this.translate.instant("LblOdometerLogTrail");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      "personName",
      "companyName",
      "licenceTag"
    ];

    if (this.authService.GetHighestRoleLevel() <= RoleLevel.Instance) {
      this.DataListModel.searchField.push("instanceName");
    }

    this.chkDescription = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      this.chkDescription
    );

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlOdometerLogTrailUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE
    );
    this.urlOdometerLogTrailAdd = this.authService.GetURL(
      ApplicationRouteURL.URL_ODOMETERLOGTRAIL_ADD
    );
    this.urlPersonInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );

    this.GetOdometerLogTrailList();
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);

    this.addOdometerLogTrailLink = new WeGoAuthorizedLink(this.urlOdometerLogTrailAdd, 
      Permission.PR_ODOMETER_LOG_TRAIL, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOdometerLogTrailList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetOdometerLogTrailList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOdometerLogTrailList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOdometerLogTrailList();
  }

  public OnDescriptionFilterChange() {
    this.GetOdometerLogTrailList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.odometerLogTrailService
      .ExportOdometerLogTrailList(this.DataListModel, this.chkDescription)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName =
              "odometerLogTrailList" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetOdometerLogTrailList() {
    this.isLoading = true;
    this.odometerLogTrailService
      .GetOdometerLogTrail(this.DataListModel, this.chkDescription)
      .subscribe(
        res => {
          this.odometerLogTrailList = res.data;
          this.isParentCheckEnable =
            this.odometerLogTrailList.filter(
              x => x.descriptionOfDeviation == null
            ).length > 0
              ? true
              : false;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnParentCheck(isChecked: boolean) {
    this.odometerLogTrailList
      .filter(x => x.descriptionOfDeviation == null)
      .forEach(x => (x.isChecked = isChecked));
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  onSubmit(forms: any) {
    this.model.listOfOdometerLogTrailHashId = this.odometerLogTrailList
      .filter(x => x.isChecked)
      .map(x => x.odometerLogTrailHashId);
    this.DeviationDescription(JSON.stringify(this.model));
  }

  public DeviationDescription(formData: any) {
    this.isLoading = true;
    this.odometerLogTrailService
      .UpdateDescriptionOfDeviation(formData)
      .subscribe(
        res => {
          if (res.data) {
            this.DataListModel.currentPage = 1;
            this.GetOdometerLogTrailList();
            this.descriptionModal.hide();
            let replaceWord = this.translate.instant(
              "LblDescriptionOfDeviation"
            );
            this.popupMsg = this.translate.instant("LblRecordUpdatedSuccess", [
              replaceWord
            ]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnCustomeButton(): void {
    this.model.descriptionOfDeviation = null;
    this.errorModel = null;
    this.descriptionModal.show();
  }

  public HideDescriptionModal(): void {
    this.descriptionModal.hide();
  }

  public SuccessCancelModalClick(): void {
    this.descriptionModal.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + "_model",
      this.chkDescription
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/odometerlogtrail/components/odometerlogtrail-list.component.ts